import React from 'react';

export default function Market() {
	return (
		<div className="main">
			<p style={{fontSize:"20px", color:"var(--text-color)"}}>MARKET</p>
		</div>
	);
}